import { NavLink } from "react-router-dom";

const NavItem = ({ link, name, children, onClick }) => {
  return (
    <NavLink
      to={link}
      exact
      onClick={onClick}
      className="
        px-3 py-2 rounded-md font-medium transition
        text-gray-700 hover:text-blue-600
      "
      activeClassName="
        text-blue-600 border-b-2 border-blue-600
      "
    >
      {children || name}
    </NavLink>
  );
};

export default NavItem;
